/* eslint-disable */
import { ASSISTED_USERS_MYSELF } from '@ringcentral-integration/commons/modules/Meeting';
export default {
  date: 'Datum',
  time: 'Uhrzeit',
  hours: '{howMany} Std.',
  minutes: '{howMany} Min.',
  today: 'Heute',
  duration: 'Dauer',
  topic: 'Titel der Besprechung',
  voIPOnly: 'Nur Internet-Audio',
  telephonyOnly: 'Nur Telefon',
  both: 'Telefon und Internet-Audio',
  thirdParty: 'Drittanbieter-Audio',
  meetingId: 'Besprechungs-ID',
  password: 'Kennwort',
  video: 'Video',
  audio: 'Audio',
  scheduleFor: 'Ansetzen im Namen von',
  [ASSISTED_USERS_MYSELF]: 'Mir',
  meetingOptions: 'Besprechungsoptionen',
  meetingSettings: 'Besprechungseinstellungen',
  rcMeetingSettings: 'Videobesprechungseinstellungen',
  audioOptions: 'Audio-Optionen',
  recurringMeeting: 'Wiederkehrende Besprechung',
  recurringNote:
    'Hinweis: Diese Option aktivieren, wenn "Wiederholung" ausgewählt wird',
  joinBeforeHost: 'Teilnehmern erlauben, vor dem Gastgeber teilzunehmen',
  turnOffCamera: 'Kamera für Teilnehmer ausschalten',
  turnOffHostCamera:
    'Kamera für Gastgeber bei Teilnahme an Besprechung deaktivieren',
  requirePassword: 'Kennwort erforderlich',
  enterPassword: 'Kennwort eingeben',
  setPassword: 'Kennwort festlegen *',
  passwordEmptyError: 'Besprechungskennwort erforderlich',
  rcmPasswordInvalidError:
    'Ihr Kennwort muss 1–10 Zeichen oder Ziffern lang sein und darf keine Symbole außer @, * oder - enthalten',
  rcmPasswordHintText:
    'Ihr Kennwort muss 1–10 Zeichen oder Ziffern lang sein und darf keine Symbole außer @, * oder - enthalten',
  usePersonalMeetingId: 'Persönliche Besprechungs-ID verwenden',
  pmiChangeConfirm:
    'Wenn Sie an Ihrer persönlichen Besprechung Änderungen vornehmen möchten, ',
  changePmiSettings: 'ändern Sie die PMI-Einstellungen',
  pmiSettingChangeAlert:
    'Wenn Sie die Einstellungen ändern und diese Besprechung ansetzen, verwenden alle Besprechungen mit persönlicher Besprechungs-ID dieselben aktuellen Einstellungen.',
  lockedTooltip: 'Ihr Unternehmens-Administrator verwaltet diese Einstellung',
  when: 'Wann',
  recurringDescribe:
    'Aktivieren Sie in der Kalendereinladung für die Teilnehmer die Option für Serien oder Wiederholungen.',
} as const;

// @key: @#@"date"@#@ @source: @#@"Date"@#@
// @key: @#@"time"@#@ @source: @#@"Time"@#@
// @key: @#@"hours"@#@ @source: @#@"{howMany} hr"@#@
// @key: @#@"minutes"@#@ @source: @#@"{howMany} min"@#@
// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"duration"@#@ @source: @#@"Duration"@#@
// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
// @key: @#@"voIPOnly"@#@ @source: @#@"Internet audio only"@#@
// @key: @#@"telephonyOnly"@#@ @source: @#@"Telephone only"@#@
// @key: @#@"both"@#@ @source: @#@"Telephone and Internet audio"@#@
// @key: @#@"thirdParty"@#@ @source: @#@"3rd party audio"@#@
// @key: @#@"meetingId"@#@ @source: @#@"Meeting ID"@#@
// @key: @#@"password"@#@ @source: @#@"Password"@#@
// @key: @#@"video"@#@ @source: @#@"Video"@#@
// @key: @#@"audio"@#@ @source: @#@"Audio"@#@
// @key: @#@"scheduleFor"@#@ @source: @#@"Schedule on behalf of"@#@
// @key: @#@"ASSISTED_USERS_MYSELF"@#@ @source: @#@"Myself"@#@
// @key: @#@"meetingOptions"@#@ @source: @#@"Meeting options"@#@
// @key: @#@"meetingSettings"@#@ @source: @#@"Meeting settings"@#@
// @key: @#@"rcMeetingSettings"@#@ @source: @#@"Video Meeting settings"@#@
// @key: @#@"audioOptions"@#@ @source: @#@"Audio options"@#@
// @key: @#@"recurringMeeting"@#@ @source: @#@"Recurring meeting"@#@
// @key: @#@"recurringNote"@#@ @source: @#@"Note: Enable this one when choosing \"Recurrence\""@#@
// @key: @#@"joinBeforeHost"@#@ @source: @#@"Allow participants to join before host"@#@
// @key: @#@"turnOffCamera"@#@ @source: @#@"Turn off camera for participants"@#@
// @key: @#@"turnOffHostCamera"@#@ @source: @#@"Turn off camera for host when joining meeting"@#@
// @key: @#@"requirePassword"@#@ @source: @#@"Require password"@#@
// @key: @#@"enterPassword"@#@ @source: @#@"Enter Password"@#@
// @key: @#@"setPassword"@#@ @source: @#@"Set password *"@#@
// @key: @#@"passwordEmptyError"@#@ @source: @#@"Meeting password required"@#@
// @key: @#@"rcmPasswordInvalidError"@#@ @source: @#@"Your password must be 1-10 characters, numbers long and cannot have symbols except @, * or -"@#@
// @key: @#@"rcmPasswordHintText"@#@ @source: @#@"Your password should be 1-10 characters, numbers long and cannot have symbols except @, * or -"@#@
// @key: @#@"usePersonalMeetingId"@#@ @source: @#@"Use Personal Meeting ID"@#@
// @key: @#@"pmiChangeConfirm"@#@ @source: @#@"If you want to make changes for your Personal Meeting, "@#@
// @key: @#@"changePmiSettings"@#@ @source: @#@"change PMI settings"@#@
// @key: @#@"pmiSettingChangeAlert"@#@ @source: @#@"If you change the settings and schedule this meeting, all of meetings with Personal Meeting ID will use the same latest settings."@#@
// @key: @#@"lockedTooltip"@#@ @source: @#@"This setting is managed by your company admin"@#@
// @key: @#@"when"@#@ @source: @#@"When"@#@
// @key: @#@"recurringDescribe"@#@ @source: @#@"Please remember to check recurrence or repeat in your calendar invitation to your attendees."@#@
